import emailService from '../services/emailService';

const handleResponse = (result, fallbackMessage) => {
  if (!result?.success) {
    const error = new Error(result?.message || fallbackMessage);
    error.details = result;
    throw error;
  }
  return result;
};

export const sendEmail = async (payload) => {
  const result = await emailService.sendEmail(payload);
  return handleResponse(result, 'E-posta gönderilemedi').data;
};

export const sendEmailWithTemplate = async (payload) => {
  const result = await emailService.sendEmailWithTemplate(payload);
  return handleResponse(result, 'E-posta şablon ile gönderilemedi').data;
};

export const fetchSentEmails = async (params = {}) => {
  const result = await emailService.getSentEmails(params);
  const handled = handleResponse(result, 'Gönderilmiş e-postalar alınamadı');
  return {
    data: handled.data || [],
    meta: handled.metaData || {
      totalCount: handled.data?.length || 0,
      pageSize: params?.pageSize || 10,
      currentPage: params?.pageNumber || 1,
      totalPages: 1,
      hasNext: false,
      hasPrevious: false,
    },
  };
};

export default {
  sendEmail,
  sendEmailWithTemplate,
  fetchSentEmails,
};


